import React from 'react';

interface CallPhaseProps {
  currentPhase: string;
  showCallInterface: boolean;
  callStatus: 'idle' | 'initiating' | 'ringing' | 'in-call' | 'ended';
  currentCall: {
    userName?: string;
    startTime?: Date;
  } | null;
  CallInterfaceComponent: React.ComponentType<{
    callStatus?: string;
    onEndCall: () => void;
    onMute: (muted: boolean) => void;
    userName: string;
    callDuration: number;
  }>;
  onEndCall: () => Promise<void>;
  onToggleMute: () => void;
}

const CallPhase: React.FC<CallPhaseProps> = ({
  currentPhase,
  showCallInterface,
  callStatus,
  currentCall,
  CallInterfaceComponent,
  onEndCall,
  onToggleMute,
}) => {
  // Accept both legacy "calling" and current "call" phase keys so UI renders
  const isCallPhase = currentPhase === 'call' || currentPhase === 'calling';
  if (!isCallPhase || !showCallInterface) {
    return null;
  }

  return (
    <>
      {/* Actief audiogesprek – gebruik WebRTC bel-UI */}
      <CallInterfaceComponent
        callStatus={callStatus}
        onEndCall={onEndCall}
        onMute={(muted) => {
          console.log('🎤 Microfoon toggle:', muted ? 'MUTED' : 'UNMUTED');
          onToggleMute();
        }}
        userName={currentCall?.userName || 'Onbekend'}
        callDuration={
          currentCall && currentCall.startTime
            ? Math.floor(
                (Date.now() - currentCall.startTime.getTime()) / 1000
              )
            : 0
        }
      />
    </>
  );
};

export default CallPhase;

